/* 🤖 this file was generated by svg-to-ts */
export const siriusUser: {
  name: 'user';
  data: string;
} = {
  name: 'user',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.537 14.795a6.75 6.75 0 1 1 6.925 0 11.252 11.252 0 0 1 6.281 5.08.75.75 0 1 1-1.299.75 9.75 9.75 0 0 0-16.888 0 .75.75 0 0 1-1.3-.75 11.25 11.25 0 0 1 6.281-5.08ZM6.75 9a5.25 5.25 0 1 1 5.323 5.25h-.146A5.25 5.25 0 0 1 6.75 9Z" fill="currentColor"/></svg>`
};
